export interface IEventLog {
    id: number;
    eventTime: string; 
    severity: string;
    loggerName: string;
    activityId: string;
    parentActivityId: string;
    applicationName: string;
    elapsedTime: string;
    elapsedSeconds: string;
    processName: string;
    message: string;
    exception: string;
}

export class EventLog implements IEventLog {
    id: number;
    eventTime: string;
    severity: string;
    loggerName: string;
    activityId: string;
    parentActivityId: string;
    applicationName: string;
    elapsedTime: string;
    elapsedSeconds: string;
    processName: string;
    message: string;
    exception: string;
}